import React, { useCallback, useMemo } from 'react';

const AppbarContext = React.createContext({
  onToogleMinimizer: () => {},
  minizeSideBar: () => {},
  expandSidebar: () => {},
});

export const useAppbar = () => React.useContext(AppbarContext);

const getBtnMinimizer = () => document.querySelector('.sidebar-minimizer');
const getStatusMinize = () => document.querySelector('body.sidebar-minimized');

const AppbarProvider = ({ children }) => {
  const onToogleMinimizer = useCallback(() => {
    const DOMminimizer = document.querySelector('.sidebar-minimizer');
    if (DOMminimizer) {
      DOMminimizer.click();
    }
  }, []);

  const minizeSideBar = useCallback(() => {
    const DOMminimizer = getBtnMinimizer();
    const statusMinizer = getStatusMinize();

    if (statusMinizer) {
      return;
    }

    if (DOMminimizer) {
      DOMminimizer.click();
    }
  }, []);

  const expandSidebar = useCallback(() => {
    const DOMminimizer = getBtnMinimizer();
    const statusMinizer = getStatusMinize();

    if (statusMinizer) {
      if (DOMminimizer) {
        setTimeout(() => {
          DOMminimizer.click();
        }, 0);
      }
    }
  }, []);

  const value = useMemo(() => {
    return {
      onToogleMinimizer,
      minizeSideBar,
      expandSidebar,
    };
  }, [onToogleMinimizer, minizeSideBar, expandSidebar]);

  return <AppbarContext.Provider value={value}>{children}</AppbarContext.Provider>;
};

export default AppbarProvider;
